import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {

  orderdetail:'/teams/order/',
  getclients:'/teams/clients/',
  getproducts:'/teams/products/',
  createorder:'/teams/order/',
  editorder:'/teams/order/'
}



export function orderdetail (id) {
  return axios({
    url: api.orderdetail+id+'/',
    method: 'get',

  })
}
export function getclients (params) {
  return axios({
    url: api.getclients,
    method: 'get',
    params
  })
}
export function createorder (data) {
  return axios({
    url: api.createorder,
    method: 'post',
    data
  })
}
export function getproducts (params) {
  return axios({
    url: api.getproducts,
    method: 'get',
    params
  })
}
export function editorder (data) {
  return axios({
    url: api.editorder+data.id+'/',
    method: 'put',
    data
  })
}



// WEBPACK FOOTER //
// ./src/views/salerviews/editorder/api.js